import { SWStyleVariableGroupRecordType, buildStyleVariableGroupIdHelper } from "../records/SWStyleVariableGroup";
import { SWStateRecordType } from "../records/SWState";
import { getIndexAbove, sortByIndex } from "../../utils/reordering/reordering";
import { uniq } from "../../utils/uniq";
export const setupVariableGroup = (store, config)=>{
    const { group, variables } = config;
    const idHelper = buildStyleVariableGroupIdHelper(group);
    const groupStyleVariableId = idHelper.root();
    // Make sure the group exists
    if (!store.has(groupStyleVariableId)) {
        // Find the index of the last group
        const lastIndex = store.query.records("style_variable_group").__unsafe__getWithoutCapture().sort(sortByIndex).map((r)=>r.index)[0];
        store.put([
            SWStyleVariableGroupRecordType.create({
                id: groupStyleVariableId,
                index: lastIndex ? getIndexAbove(lastIndex) : "a1"
            })
        ]);
    }
    // Make sure all the modes exist
    const modes = uniq(variables.flatMap((v)=>Object.keys(v.modes)));
    let lastModeIndex = store.query.records("style_variable_group", ()=>({
            id: {
                stw: idHelper.startsWithModeQuery()
            }
        })).__unsafe__getWithoutCapture().sort(sortByIndex).map((r)=>r.index)[0];
    modes.forEach((mode)=>{
        const modeId = idHelper.mode(mode);
        if (!store.has(modeId)) {
            let nextModeIndex = lastModeIndex ? getIndexAbove(lastModeIndex) : "a1";
            store.put([
                SWStyleVariableGroupRecordType.create({
                    id: modeId,
                    index: nextModeIndex
                })
            ]);
            lastModeIndex = nextModeIndex;
        }
    });
    // Variables
    const variableIds = variables.map((v)=>idHelper.variable(v.name));
    let lastVariableIndex = store.query.records("style_variable_group", ()=>({
            id: {
                stw: idHelper.startsWithVariablesQuery()
            }
        })).__unsafe__getWithoutCapture().sort(sortByIndex).map((r)=>r.index)[0];
    variables.forEach((variable, index)=>{
        const variableId = variableIds[index];
        if (!store.has(variableId)) {
            let nextVariableIndex = lastVariableIndex ? getIndexAbove(lastVariableIndex) : "a1";
            store.put([
                SWStyleVariableGroupRecordType.create({
                    id: variableId,
                    index: nextVariableIndex
                })
            ]);
            lastVariableIndex = nextVariableIndex;
        }
        // States
        Object.entries(variable.modes).forEach(([mode, { value }])=>{
            const stateId = idHelper.state(variable.name).mode(mode);
            if (!store.has(stateId)) {
                store.put([
                    SWStateRecordType.create({
                        id: stateId,
                        defaultValue: value
                    })
                ]);
            }
        });
    });
};
